exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-b2bda1d8] {\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports
